/**
 * Pure-data English catalogue for namespace 'json' (W1-07a formats-json-rpe; imports only core/util/types).
 * Syntax errors of the lossless JSON parser (formats/json/lexer.ts `jsonSyntaxErrorRef`, keys `json.syntax.<code>`,
 * params `line`, `col` and optionally `found`). Shown by the import report, the Raw panel and every JSON reader.
 */

import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'json',
  locale: 'en',
  messages: {
    'syntax.empty': 'The file is empty.',
    'syntax.unexpectedEnd': 'The text ends too early at line {line}, column {col}. Something is not closed.',
    'syntax.unterminatedString': 'The text at line {line}, column {col} is missing its closing double quote.',
    'syntax.unexpectedChar': 'Unexpected "{found}" at line {line}, column {col}.',
    'syntax.expectedValue':
      'Expected a value at line {line}, column {col}: an object, a list, text in double quotes, a number, true, false or null.',
    'syntax.expectedKey': 'Expected a name in double quotes at line {line}, column {col}.',
    'syntax.expectedColon': 'Expected ":" after the name at line {line}, column {col}.',
    'syntax.expectedCommaOrEnd': 'Expected a comma or a closing bracket at line {line}, column {col}.',
    'syntax.trailingComma': 'Remove the comma before the closing bracket at line {line}, column {col}.',
    'syntax.badNumber': 'This number is not written correctly (line {line}, column {col}).',
    'syntax.leadingZero': 'Numbers cannot start with 0 followed by more digits (line {line}, column {col}).',
    'syntax.badEscape': 'Unknown backslash sequence in the text at line {line}, column {col}.',
    'syntax.badUnicodeEscape': 'A \\u sequence needs exactly four hexadecimal digits (line {line}, column {col}).',
    'syntax.controlChar':
      'Line breaks and tabs inside text must be written as \\n and \\t (line {line}, column {col}).',
    'syntax.trailingData': 'There is extra text after the end of the data at line {line}, column {col}.',
    'syntax.tooDeep': 'The data is nested too deeply (line {line}, column {col}).',
  },
};

export default catalog;
